import { type Theme } from "@mui/material";

interface StatusChipStyle {
  backgroundColor: string | undefined;
  color: string | undefined;
  borderColor: string | undefined;
}

export function getFacilityStatusChipStyle(status: string, theme: Theme): StatusChipStyle {
  const { statusChip } = theme.palette;
  const normalized = status.toUpperCase();

  const variant = (() => {
    switch (normalized) {
      case "ENROLLED": {
        return statusChip?.success;
      }
      case "ONBOARDING":
      case "UNSIGNED":
      case "PENDING":
      case "PROBATION": {
        return statusChip?.pending;
      }
      case "SUSPENDED":
      case "TERMINATED":
      case "ARCHIVED": {
        return statusChip?.error;
      }
      default: {
        return statusChip?.muted;
      }
    }
  })();

  return {
    backgroundColor: variant?.background,
    color: variant?.text,
    borderColor: variant?.text,
  };
}
